import axios from 'axios';
import API_BASE_URL from '../config/api.js';

let artistId = "rdv01"; // Default to rdv01 (rue_de_vivre)

const ARTIST_MANAGER_ENDPOINT = `${API_BASE_URL}/artistmanager`;

export const getArtistId = () => artistId;
export const setArtistId = (newId) => {
  artistId = newId;
};

export const setArtistIdFromUser = async () => {
  try {
    // Get current user from Cognito
    const cognitoAuthService = (await import('../services/CognitoAuthService.js')).default;
    const userResult = await cognitoAuthService.getCurrentUser();
    
    if (userResult.success && userResult.user) {
      const email = userResult.user;
      const artistId = mapEmailToArtistId(email);
      setArtistId(artistId);
      console.log(`Artist ID set to ${artistId} for user ${email}`);
    } else {
      // Fallback to default if no authenticated user
      setArtistId('rdv01');
      console.log('No authenticated user found, using default artist ID rdv01');
    }
  } catch (error) {
    console.error('Error setting artist ID:', error);
    setArtistId('rdv01'); // Default to rdv01 instead of defaultArtistId
  }
};

function mapEmailToArtistId(email) {
  const mapping = {
    'rdv@decodedmusic.com': 'rdv01', // rdv01 = rue_de_vivre
    // Add other mappings here: rdv02, rdv03, etc.
  };
  return mapping[email] || 'rdv01'; // Default to rdv01
}

export const getArtistData = async (artistId, email = null) => {
  try {
    let params = {};
    if (artistId) {
      params.artist_id = artistId;
    } else if (email) {
      params.email = email;
    } else {
      throw new Error('Either artistId or email must be provided');
    }

    const response = await axios.get(ARTIST_MANAGER_ENDPOINT, { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching artist data:', error);
    throw error;
  }
};

export const setArtistData = async (artistData) => {
  try {
    const response = await axios.post(ARTIST_MANAGER_ENDPOINT, artistData);
    return response.data;
  } catch (error) {
    console.error('Error setting artist data:', error);
    throw error;
  }
};